import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  EMAIL_REGEX,
  PASSWORD_REGEX,
  PHONE_REGEX,
} from "../../../utilities/regex";
import useGetUserRoles from "../../../hooks/masters/users/useGetUserRoles";
import useCreateEditUser from "../../../hooks/masters/users/useCreateEditUser";
import CreateEditUserForm from "./CreateEditUserForm";

const AddUser = () => {
  const navigate = useNavigate();

  const { userRoles } = useGetUserRoles();

  const userRolesOptions = userRoles?.map?.((role) => ({
    value: role.name,
    label: role.description,
  }));

  const {
    createUser,
    register,
    handleSubmit,
    errors,
    watch,
    control,
    getValues,
    setValue,
  } = useCreateEditUser();

  return (
    <div className="container_xxl relative z-10 px-4">
      <div className="flex items-center space-x-4 headingBorder__b">
        <div>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
        </div>
        <div>
          <h1 className="heading">Add User</h1>
        </div>
      </div>

      <CreateEditUserForm
        register={register}
        handleSubmit={handleSubmit}
        errors={errors}
        onSubmit={createUser}
        watch={watch}
        control={control}
        getValues={getValues}
        setValue={setValue}
        userRolesOptions={userRolesOptions}
      />
    </div>
  );
};

export default AddUser;
